import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {makeApiCall, makeApiCallPost} from '../../Api/makeApiCall';
import {CONFIG_TYPES, ConfigType} from './FileTypes';
import {getUserEmail} from "../../auth/accessTokenValidator";
import {getMoment} from "../../utils/time";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import {addLabelToOptionsIfNotExist} from "../../utils/maybeAddLabelToOptions";
import SelectDropdown from "../Components/Dropdowns/SelectDropdown";

const FtpConfigs = ({
                        buttonTitle,
                        ftp,
                        className,
                        configType,
                        isModalMode = true,
                        setIsPopoverOpen
                    }) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [configTypes, setConfigTypes] = useState(undefined);
    const [value, setValue] = useState(undefined);
    const [metadata, setMetadata] = useState(undefined);
    const [originalValue, setOriginalValue] = useState(undefined);
    const [selectedSalesConfig, setSelectedSalesConfig] = useState(undefined);


    function closeModal() {
        setModalIsOpen(false);
        if (typeof setIsPopoverOpen === 'function') {
            setIsPopoverOpen(false);
        }
    }

    function updateIngestMapping() {

        let parsedConfig, parsedOriginalConfig;

        try {
            parsedConfig = JSON.parse(value);
            parsedOriginalConfig = originalValue && JSON.parse(originalValue);
        } catch (e) {
            alert('Error: You tried to save invalid JSON.');
            console.error('=============> e: ', e);
            return;
        }

        if (!configType.shouldSaveConfig(parsedConfig, ftp, parsedOriginalConfig)) return;

        const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/ftpConfig/?ftp=${selectedSalesConfig || ftp}&configType=${configType.getName()}`;
        const metadataForPost = metadata || {}
        if (!metadataForPost?.updates) {
            metadataForPost.updates = []
        }

        metadataForPost.updates.push({user: getUserEmail(), timestamp: getMoment().toISOString()})

        makeApiCallPost(endpointUrl, JSON.stringify({...parsedConfig, metadata: metadataForPost}))
            .then(() => closeModal());
    }

    const prepareConfigTypeMapping = configTypesMapping => {
        return configTypesMapping && configTypesMapping.length ? configTypesMapping.map(mapping => {
                return {label: mapping.filename, value: mapping.filename.replace('.json', '')};
            }
        ) : undefined;
    };

    const loadFileTypesConfigs = () => {
        const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/ftpConfig/?ftp=${ftp}&configType=${CONFIG_TYPES.FILE_TYPE.getName()}`;
        makeApiCall(endpointUrl).then(response => {
            const ftpConfigs = prepareConfigTypeMapping(response[`${configType.getName()}_mappings`]);
            const defaultSalesConfig = ftpConfigs && ftpConfigs.length ? ftpConfigs[0].value : undefined;
            setConfigTypes(ftpConfigs);
            setModalIsOpen(isModalMode);
            setSelectedSalesConfig(defaultSalesConfig);
            return defaultSalesConfig;
        }).then((defaultSalesConfig) => {
            if (defaultSalesConfig === undefined) {
                loadIngestMapping();
            }
        });
    };

    const loadIngestMapping = () => {
        const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/ftpConfig/?ftp=${selectedSalesConfig || ftp}&configType=${configType.getName()}`;
        let metadataObject = undefined
        makeApiCall(endpointUrl).then(response => {
            if (response?.metadata) {
                metadataObject = response.metadata
                delete response.metadata
            }

            setMetadata(metadataObject);
            setValue(JSON.stringify(response, null, 2));
            setOriginalValue(JSON.stringify(response, null, 2));
            setModalIsOpen(isModalMode);
        });
    };

    useEffect(() => {
        if (!isModalMode) loadFileTypesConfigs()
    }, [])

    useEffect(() => {
        if (selectedSalesConfig) loadIngestMapping();
    }, [selectedSalesConfig]);

    const modalContent = <>
        <div data-testid={'modal-content'}>
            <div className={"modal-ftp-configuration-header"}>
                <h2>{configType.getName()} config [{ftp}]</h2>
                {
                    configTypes &&
                    <div className={"modal-ftp-configuration-dropdown"}>
                        <SelectDropdown
                            id={"modal-ftp-configuration_dropdown"}
                            classNamePrefix={"modal-ftp-configuration-dropdown"}
                            options={addLabelToOptionsIfNotExist(configTypes) || []}
                            selectValue={selectedSalesConfig}
                            selectLabel={`${selectedSalesConfig}.json`}
                            onChange={(selection) => setSelectedSalesConfig(selection?.value)}
                        />
                    </div>
                }
            </div>

            <AceEditor
                mode="json"
                theme="github"
                onChange={(value) => setValue(value)}
                name="ace_editor_01"
                editorProps={{$blockScrolling: true}}
                value={value}
                setOptions={{useWorker: false}}
            />
            <div className={"right-things"}>
                {isModalMode && <button className="button cancel modal-button" type="button" name="close"
                                        onClick={() => closeModal()}>
                    Close
                </button>}
                <button className="button primary modal-button" type="button"
                        onClick={() => updateIngestMapping(value)}>
                    Update
                </button>
            </div>
        </div>
    </>;

    return (
        <>
            {!isModalMode && <div>{modalContent}</div>}
            {isModalMode && <div data-testid={'modal'} className={"ftp-configs-modal-button"}>
                <button className="button tertiary mapping"
                        onClick={() => loadFileTypesConfigs()}>{buttonTitle}
                </button>
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    className="Modal ftp-configs-modal"
                    overlayClassName="Overlay"
                    ariaHideApp={false}>
                    {modalContent}
                </Modal>
            </div>
            }
        </>
    );
}

FtpConfigs.propTypes = {
    buttonTitle: PropTypes.string,
    ftp: PropTypes.string,
    className: PropTypes.string,
    configType: PropTypes.instanceOf(ConfigType).isRequired,
    isModalMode: PropTypes.bool,
    shouldAllowToSaveConfig: PropTypes.func,
    setIsPopoverOpen: PropTypes.func
};

export default FtpConfigs
